// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"demo-switch_buttonContainer__3_yQJ","button":"demo-switch_button__3-RLY"};